import { Controller } from "@hotwired/stimulus";
import Reveal from "reveal.js/dist/reveal.js";

export default class extends Controller {
  static targets = ["section", "item"];

  connect() {
    Reveal.on("slidechanged", e => this.updateCurrentSlide(e));
  }

  toggle() {
    this.element.classList.toggle("is-open");
    this.element.classList.toggle("is-closed");
  }

  updateCurrentSlide(e) {
    this.resetCurrent();

    const item = this.getItemForIndices(e.indexh, e.indexv);

    if (item) {
      item.classList.add("is-current");
    }
  }

  resetCurrent() {
    this.itemTargets.forEach(item => item.classList.remove("is-current"));
  }

  getItemForIndices(h, v) {
    const section = this.getSectionByIndice(h);

    if (!section || v === 0) return false;

    const item = this.getItemByIndice(section, v);
    return item;
  }

  getSectionByIndice(h) {
    return this.sectionTargets.find(
      section => Number(section.getAttribute("data-indice")) === h
    );
  }

  getItemByIndice(section, v) {
    const items = section.querySelectorAll(".reveal-toc-section-item");
    const itemsBelow = Array.from(items).filter(
      item => Number(item.getAttribute("data-indice")) <= v
    );
    return itemsBelow.pop();
  }
}
